<template>
  <Page key="Inform" :query-api="queryApi" />
</template>
<script>
import { purchaseApi } from '@/api';
import Page from '../components/commonPage.vue';
export default {
  name: 'BusinessPurchaseEntryInform',
  components: {
    Page,
  },
  data() {
    return {
      queryApi: purchaseApi.getStockins,
    };
  },
};
</script>
